import { useUser } from '~/@biz_account/useUser/useUser'
import * as Onboarding from '../_layout/OnboardingComponents'
import { PhoneVerificationContent } from './_layout/PhoneVerificationContent'
import { PhoneVerificationSideMenu } from './_layout/PhoneVerificationSideMenu'

function PhoneVerificationPage() {
  const { user } = useUser()
  return (
    <Onboarding.Container>
      <Onboarding.ContainerContent>
        <PhoneVerificationContent />
      </Onboarding.ContainerContent>

      <Onboarding.ContainerSideMenu>
        <div className="hidden lg:flex lg:col-span-1 justify-center items-center md:px-20 bg-foreground text-primary-foreground">
          <PhoneVerificationSideMenu
            isCompany={user?.profile?.isCompany ?? false}
          />
        </div>
      </Onboarding.ContainerSideMenu>
    </Onboarding.Container>
  )
}

export default PhoneVerificationPage
